<template>
  <div id="export-index">
    <div class="panel">
      <div class="panel-head">
        <h2>CSV Exports</h2>
      </div>

      <div class="panel-content">

        <div
          v-for="(report, reportKey) in reports"
          class="report"
          :key="reportKey">
          <div class="report__title">{{report.title}}</div>
          <div class="report__action">
            <div class="form-control-group">
              <button
                @click.prevent="downloadReport(reportKey)"
                class="button button-blue-alt">
                Download
              </button>
              <template v-if="report.isAnnualReport">
                <select
                  v-model="report.reportYear"
                  class="report__years-control">
                  <option
                    v-for="year in report.yearsOfData"
                    :value="year"
                    :selected="year === report.reportYear"
                    :key="year">
                    {{year}}
                  </option>
                </select>
              </template>
            </div>
          </div>
        </div>




        <br/><br/><br/><br/>
        <p>Legacy:</p>
        <p>
          <a @click.prevent="clientSummary()" class="report--client-summary" href="#">Client Summary (Current Year)</a>
        </p>
        <p>
          <a @click.prevent="clientSummaryV2()" class="report--client-summary-prev-year" href="#">Client Summary (Previous Year)</a>
        </p>
        <p>
          <a @click.prevent="clientTotals()" class="report--client-totals" href="#">Client Totals</a>
        </p>
        <p>
          <a @click.prevent="clientContacts()" class="report--client-contacts" href="#">Client Contacts</a>
        </p>
        <p>
          <a @click.prevent="clientTeams()" class="report--client-teams" href="#">Client Teams</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExportIndex",
  data() { return {
    reports: {
      clientSummary: {
        title: 'Client Summary Report',
        filename: 'client-summary-report-{{year}}',
        isAnnualReport: true,
        yearsOfData: this.yearsSince(2020),
        reportYear: null,
      },
      clientTotals: {
        title: 'Client Totals Report',
        filename: 'client-totals-report-{{year}}',
        isAnnualReport: true,
        yearsOfData: this.yearsSince(2018),
        reportYear: null,
      },
      clientContacts: {
        title: 'Client Contacts Report',
        filename: 'client-contacts-report',
        isAnnualReport: false,
      },
      clientTeams: {
        title: 'Client Teams Report',
        filename: 'client-teams-report',
        isAnnualReport: false,
      },
    },
  }},
  mounted: function() {
    for(var report in this.reports) {
      if(this.reports.hasOwnProperty(report)) {
        if(this.reports[report].isAnnualReport) {
          this.reports[report].reportYear = this.reports[report].yearsOfData[0];
        }
      }
    }
  },
  methods: {
    downloadReport(report) {
      var requestParams = [];
      requestParams.push('report='+report);
      if(this.reports[report].isAnnualReport) {
        requestParams.push('year='+this.reports[report].reportYear);
      }
      this.$http
        .get('/csv-exports/download?'+requestParams.join('&'))
        .then(response => {
          console.log(response);
          var finalReport = {
            filename: this.reports[report].filename + '.csv',
            data: null,
          };
          if(this.reports[report].isAnnualReport) {
            finalReport.filename = finalReport.filename.replace('{{year}}', this.reports[report].reportYear);
          }
          finalReport.data = new Blob([response.data], {
            type: 'text/csv;charset=utf-8;'
          });
          if(navigator.msSaveBlob) {
            navigator.msSaveBlob(finalReport.data, finalReport.filename);
          } else {
            var tempDownloadLink = document.createElement('a');
            tempDownloadLink.href = window.URL.createObjectURL(finalReport.data);
            tempDownloadLink.setAttribute('download', finalReport.filename);
            document.body.appendChild(tempDownloadLink);
            tempDownloadLink.click();
            document.body.removeChild(tempDownloadLink);
          }
        });
    },
    yearsSince(alpha, omegaOffset = 0) {
      var years = [];
      var alphaYear = parseInt(alpha);
      var omegaYear = (new Date()).getFullYear(); // this year
      omegaYear += parseInt(omegaOffset);
      for(var y = alphaYear; y <= omegaYear; y++) {
        years.push(y);
      }
      return years.reverse();
    },



    clientSummary() {
      this.$http
        .get("/client-summary-export")
        .then(response => {
          // Return CSV to browser
          console.log(response);
          var csvData = new Blob([response.data], {
            type: "text/csv;charset=utf-8;"
          });
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(csvData, "client-summary.csv");
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(csvData);
            link.setAttribute("download", "client-summary.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clientSummaryV2() {
      this.$http
        .get("/client-summary-export-v2")
        .then(response => {
          // Return CSV to browser
          console.log(response);
          var csvData = new Blob([response.data], {
            type: "text/csv;charset=utf-8;"
          });
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(csvData, "client-summary.csv");
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(csvData);
            link.setAttribute("download", "client-summary.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clientTotals() {
      this.$http
        .get("/client-totals-export")
        .then(response => {
          // Return CSV to browser
          var csvData = new Blob([response.data], {
            type: "text/csv;charset=utf-8;"
          });
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(csvData, "client-totals.csv");
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(csvData);
            link.setAttribute("download", "client-totals.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clientContacts() {
      this.$http
        .get("/client-contacts-export")
        .then(response => {
          // Return CSV to browser
          var csvData = new Blob([response.data], {
            type: "text/csv;charset=utf-8;"
          });
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(csvData, "client-contacts.csv");
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(csvData);
            link.setAttribute("download", "client-contacts.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clientTeams() {
      this.$http
        .get("/client-teams")
        .then(response => {
          // Return CSV to browser
          var csvData = new Blob([response.data], {
            type: "text/csv;charset=utf-8;"
          });
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(csvData, "client-teams.csv");
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(csvData);
            link.setAttribute("download", "client-teams.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
#export-index {
  .report {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: solid 1px #f2f2f2;
    &__title {
      font-size: 18px;
      font-weight: bold;
    }
    &__action {
      margin-top: 2px;
      .form-control-group {
        justify-content: flex-start;
      }
      button {
        margin: 0;
        padding-top: 9px;
        padding-bottom: 9px;
      }
    }
    &__years-control {
      width: auto;
      margin-left: 5px;
    }
  }
}
</style>